module.exports = __webpack_public_path__ + "img/homechart.442724fa.png";